/**
 * Super-admin analytics service — wraps /api/v1/admin/analytics/*.
 * Uses the shared axios instance (Bearer token auto-attached).
 */
import api from '../shared/services/api';

export interface AnalyticsOverview {
  tenants: {
    total: number;
    by_status: Record<string, number>;
    by_plan: { code: string | null; name: string | null; count: number }[];
  };
  users: {
    total: number;
    active: number;
    inactive: number;
    by_role: Record<string, number>;
  };
  usage: { documents_this_month: number };
}

export interface TenantAnalyticsRow {
  id: string;
  name: string;
  slug: string;
  status: string;
  plan_code: string | null;
  plan_name: string | null;
  users: number;
  monthly_documents_used: number;
  monthly_document_limit: number;
}

export interface UsagePoint {
  date: string;
  success: number;
  failed: number;
  total: number;
}

export interface UsageSeries {
  tenant_id: string | null;
  days: number;
  series: UsagePoint[];
}

export async function getAnalyticsOverview(): Promise<AnalyticsOverview> {
  const r = await api.get<AnalyticsOverview>('/api/v1/admin/analytics/overview');
  return r.data;
}

export async function getTenantAnalytics(): Promise<TenantAnalyticsRow[]> {
  const r = await api.get<TenantAnalyticsRow[]>('/api/v1/admin/analytics/tenants');
  return r.data;
}

export async function getUsageSeries(
  tenantId?: string | null,
  days = 30,
): Promise<UsageSeries> {
  const r = await api.get<UsageSeries>('/api/v1/admin/analytics/usage', {
    params: { ...(tenantId ? { tenant_id: tenantId } : {}), days },
  });
  return r.data;
}
